<template>
  <v-container>
    <v-row>
      <v-col class="px-0">
        <v-card
          class="pa-5"
          :style="{ border: '1px solid var(--primary-boarder-color)' }"
        >
          <PageTitleWithSearch
            :title="'Projects'"
            :loading="loading"
            :search="search"
            @searchText="searchChange($event)"
          ></PageTitleWithSearch>
          <v-row v-if="projects">
            <v-col>
              <div>
                <div>
                  <v-data-table
                    :headers="headers"
                    :items="projects"
                    :items-per-page="5"
                    :hide-default-footer="true"
                    :disable-sort="true"
                    :disable-pagination="true"
                    id="data-table"
                  >
                    <template v-slot:item="{ item, index }">
                      <tr
                        :class="index % 2 === 0 ? 'dark-row' : 'light-row'"
                        class="custom-row"
                      >
                        <td>{{ item.project_code }}</td>
                        <td class="text-left">
                          <router-link
                            :to="'/project/info/' + item.uuid"
                            class="router-link font-weight-medium"
                          >
                            {{ item.project_name }}
                          </router-link>
                        </td>
                        <td class="text-center" v-if="item.status">
                          <v-chip
                            class="ma-2"
                            small
                            :color="getStatusColors(item.status).chip"
                            :text-color="getStatusColors(item.status).text"
                          >
                            {{ stringFormatting(item.status) }}
                          </v-chip>
                        </td>
                        <td class="text-left">{{ item.start_date }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </div>
              <v-row class="my-1">
                <Pagination
                  v-model="page"
                  :loading="loading"
                  :total="total"
                  :page="page"
                ></Pagination>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col>
              <v-alert type="info">No project information available.</v-alert>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { filters } from "../../utility/filters";
import { createNamespacedHelpers } from "vuex";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import Pagination from "@/components/shared/Pagination";
const { mapGetters } = createNamespacedHelpers("auth");
import { CustomerService } from "@/services/customer-service.js";
import { checkError } from "@/config/errors.js";
import { getStatusColors } from "@/utility/statusColors.js";

export default {
  name: "CustomerInfo",
  components: { PageTitleWithSearch, Pagination },
  data() {
    return {
      projects: [],
      page: 1,
      search: "",
      loading: false,
      total: 0,
      totalProject: 0,
      defaultImage: require("@/assets/img/avatar.svg"),
      headers: [
        { text: "Code", value: "project_code", align: "start" },
        { text: "Project Name", value: "project_name", align: "start" },
        { text: "Status", value: "status", align: "center" },
        { text: "Create Date", value: "due_date", align: "start" },
      ],
    };
  },

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getProjects();
  },

  watch: {
    search() {
      this.page = 1;
      this.getProjects();
    },
    page() {
      this.getProjects();
    },
  },

  methods: {
    getProjects() {
      this.loading = true;
      CustomerService.getProjects(
        this.$route.params.uuid,
        this.search,
        this.page
      )
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.projects = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalProject = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getProfileColor(letter) {
      return filters.getProfileColor(letter);
    },
    searchChange(value) {
      this.search = value;
    },
    getStatusColors(status) {
      return getStatusColors(status);
    },
  },
};
</script>
